import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'

function PhoneSendCode({ onClick, sending, nextAttempt, getCodeRef }) {
  const [counter, setCounter] = useState(nextAttempt - dayjs().unix())

  let countdownTimer

  useEffect(() => {
    if (counter > 0) {
      countdown()
    }
    return () => {
      if (countdownTimer) {
        clearTimeout(countdownTimer)
      }
    }
  })

  useEffect(() => {
    if (nextAttempt == null) {
      if (countdownTimer) {
        clearTimeout(countdownTimer)
      }
      setCounter(0)
    } else {
      countdown()
    }
  }, [nextAttempt])

  const countdown = () => {
    const getCounter = nextAttempt - dayjs().unix()
    if (getCounter !== counter) {
      setCounter(getCounter)
    }

    if (counter > 0) {
      countdownTimer = setTimeout(countdown, 100)
    }
  }

  const waiting = counter > 0

  return sending ? (
    <div className="account-form__code-timer">Отправка...</div>
  ) : waiting ? (
    <div className="account-form__code-timer">
      Повторный код можно запросить через <strong>{counter}</strong> сек
    </div>
  ) : (
    <div className="account-form__get-code" ref={getCodeRef} onClick={onClick}>
      <span>Получить код</span>
    </div>
  )
}

PhoneSendCode.defaultProps = {
  onClick: () => {}
}

export default PhoneSendCode
